/**
 * @fileoverview added by tsickle
 * Generated from: models/housekeep-device.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { model } from '../util/model';
/** @enum {string} */
var FcmState = {
    Active: "active",
    Inactive: "inactive",
};
/**
 * Model representing a device.
 * @record
 */
export function HousekeepDevice() { }
if (false) {
    /**
     * The app version.
     * @type {?}
     */
    HousekeepDevice.prototype.appVersion;
    /**
     * The Firebase Cloud Messaging state.
     * @type {?|undefined}
     */
    HousekeepDevice.prototype.fcmState;
    /**
     * The Firebase Cloud Messaging token.
     * @type {?|undefined}
     */
    HousekeepDevice.prototype.fcmToken;
    /**
     * The device model, as set by the manufacturer.
     * @type {?}
     */
    HousekeepDevice.prototype.model;
    /**
     * The device manufacturer.
     * @type {?}
     */
    HousekeepDevice.prototype.manufacturer;
    /**
     * The operating system name e.g. "android", "ios".
     * @type {?}
     */
    HousekeepDevice.prototype.platform;
    /**
     * The operating system version.
     * @type {?}
     */
    HousekeepDevice.prototype.osVersion;
    /**
     * The device's hardware serial number (Android only).
     * @type {?}
     */
    HousekeepDevice.prototype.serial;
    /**
     * The device's Universally Unique Identifier (UUID).
     * @type {?}
     */
    HousekeepDevice.prototype.uuid;
}
/** @type {?} */
export var housekeepDevice = model.extend((/** @type {?} */ ({
    modelName: 'housekeepDevice'
})));
